import { CURRENCY, SWAP_CURRENCY } from '~/types'
import { SWAP_ACTIONS } from './const'

// DATA TYPES
export enum FX_ACTION_STATUS {
  NOT_FETCHED,
  FETCHING,
  FAILED,
  SUCCESS,
}
export type SwapCurrencyPair = [CURRENCY, CURRENCY]
export enum FIXED_SIDE {
  SELL = 'sell',
  BUY = 'buy',
}
export type FXQuote = {
  sourceAmount: number
  destinationAmount: number
  sourceCurrency: string
  destinationCurrency: string
  id: string
  rate: number
  expiresAt: string
  expiresIn: number
}

export type SwapTransactionLimitMap = {
  [currency: string]: SwapTransactionLimit
}

export type SwapTransactionLimit = {
  currency: CURRENCY
  maximumAmount: number
  minimumAmount: number
}

export type CurrencyPair = {
  pair: [SWAP_CURRENCY, SWAP_CURRENCY]
  disabled: boolean
}

export type SwapPrefill = {
  sourceCurrency: CURRENCY
  destCurrency: CURRENCY
  sourceAmount: string
  destAmount: string
  fixedSide: FIXED_SIDE
}
// END DATA TYPES

// ACTION TYPES
type SetFXRateAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_FX_RATE
  data: number | undefined
}

type SetFXRateStatusAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_FX_RATE_STATUS
  status: FX_ACTION_STATUS
}

type SetFXQuoteAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_FX_QUOTE
  data: FXQuote | undefined
}

type SetFXQuoteStatusAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_FX_QUOTE_STATUS
  status: FX_ACTION_STATUS
}

type SetSwapTransactionLimitsAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_TRANSACTION_LIMITS
  transactionLimits: SwapTransactionLimit[]
}

type SetShouldHighlightSwapFormAction = {
  type: typeof SWAP_ACTIONS.SET_SHOULD_HIGHLIGHT_SWAP_FORM
  shouldHighlightSwapForm: boolean
}

type SetSwapPrefillAction = {
  type: typeof SWAP_ACTIONS.SET_SWAP_FORM_PREFILL
  swapPrefill: SwapPrefill | null
}

export type ActionTypes =
  | SetFXRateAction
  | SetFXRateStatusAction
  | SetFXQuoteAction
  | SetFXQuoteStatusAction
  | SetSwapTransactionLimitsAction
  | SetShouldHighlightSwapFormAction
  | SetSwapPrefillAction
// END ACTION TYPES
